export default {
    CUST_GROUP_ALL: 32000
}


// WEBPACK FOOTER //
// ./src/view/constant/customer/CustomerGroupConstant.js